import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-a4c3a3a2"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = ["cn"];
var _hoisted_2 = {
  class: "record-item"
};
var _hoisted_3 = {
  class: "title"
};
var _hoisted_4 = {
  class: "content"
};
var _hoisted_5 = ["src"];
var _hoisted_6 = {
  class: "record-item"
};
var _hoisted_7 = {
  class: "title"
};
var _hoisted_8 = {
  class: "content"
};
var _hoisted_9 = ["src"];
var _hoisted_10 = {
  class: "record-item"
};
var _hoisted_11 = {
  class: "title"
};
var _hoisted_12 = {
  class: "content"
};
var _hoisted_13 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: "snore-record",
    cn: $data.isCn
  }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("message.snore.recordSnoreTitle1")), 1), _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("message.snore.recordSnoreContent1")), 1), _createElementVNode("img", {
    src: $data.imgRecord1,
    alt: ""
  }, null, 8, _hoisted_5)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("message.snore.recordSnoreTitle2")), 1), _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("message.snore.recordSnoreContent2")), 1), _createElementVNode("img", {
    src: $data.imgRecord2,
    alt: ""
  }, null, 8, _hoisted_9)]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("message.snore.recordSnoreTitle3")), 1), _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("message.snore.recordSnoreContent3")), 1), _createElementVNode("img", {
    src: $data.imgRecord3,
    alt: ""
  }, null, 8, _hoisted_13)])], 8, _hoisted_1);
}